import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { IImageList } from '@web-nx-ng-tsc/web-shared-data-access';
import { RouterLink } from '@angular/router';
import { ROUTER_TOKENS } from '../../../../../../../apps/promo-web/web-toyo/src/app/app.routes';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';

@Component({
  selector: 'lib-web-shared-ui-news-card',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './lib-news-card.component.html',
  styleUrl: './lib-news-card.component.scss',
})
export class LibNewsCardComponent {
  @Input() set data(value: IImageList) {
    this.dataSignal.set(value);
  }

  @Input() set pathName(value: string) {
    this.pathNameSignal.set(value);
  }

  @Input() headingLevel: 'h2' | 'h3' = 'h2';
  @Output() emitNewsUrl = new EventEmitter();

  protected readonly ROUTER_TOKENS = ROUTER_TOKENS;
  public readonly replaceBucket = new ReplaceBucket();

  dataSignal = signal<IImageList>({
    img: '',
    title: '',
    excerpt: '',
    id: 0,
  });

  pathNameSignal = signal<string>(this.ROUTER_TOKENS.NEWS);
}
